import isBrowser from './isBrowser';
import isInIframe from './isInIframe';
import isInPopoverWidget from './isInPopoverWidget';
import isInPopoverWidgetLauncher from './isInPopoverWidgetLauncher';
import {
  isChargeProduct,
  isChatProduct,
  isConsultationProduct,
  isInPersonProduct,
  isLiteProduct,
  isLiveSessionProduct,
  isSubscriptionProduct,
} from './isProductType';

export function getId(strangeId) {
  const [, justId] = strangeId.split(':');
  return justId || strangeId;
}

export function getDateFormat(date) {
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  return new Date(date).toLocaleDateString('en-US', options);
}

export function getDateTimeFormat(date) {
  const options = {
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    month: 'short',
    year: 'numeric',
  };
  return new Date(date).toLocaleDateString('en-US', options);
}

export {
  isChargeProduct,
  isConsultationProduct,
  isInIframe,
  isChatProduct,
  isLiteProduct,
  isInPersonProduct,
  isLiveSessionProduct,
  isSubscriptionProduct,
  isInPopoverWidget,
  isInPopoverWidgetLauncher,
  isBrowser,
};
